export const BASE_URL = 'https://api.smartrec.ng/api';